export function convertSnakeToStartCase(string) {
  if (string) {
    if (string.includes('_')) {
      return string
        .split('_')
        .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
        .join(' ')
    } else {
      return string.charAt(0).toUpperCase() + string.slice(1)
    }
  } else {
    return ''
  }
}
export function convertSpaceToStartCase(string) {
  if (string) {
    if (string.includes(' ')) {
      return string
        .split(' ')
        .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
        .join(' ')
    } else {
      return string.charAt(0).toUpperCase() + string.slice(1)
    }
  } else {
    return ''
  }
}
export function formatQuantity(value) {
  if (isNaN(value)) {
    return '0'
  } else {
    const formatter = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    })
    try {
      return formatter.format(value)
    } catch (error) {
      return '0'
    }
  }
}

export function formatQuantityInt(value) {
  if (isNaN(value)) {
    return '0'
  } else {
    const formatter = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      roundingMode: 'floor', // or 'trunc' for toward-zero
    })
    try {
      return formatter.format(value)
    } catch (error) {
      return '0'
    }
  }
}
